// Constellation
import { Box, Checkbox, FieldSet, Heading, Label, LabeledControl, Radio } from '@zillow/constellation-10';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticState } from '../../utils/hooks';
import { dotStyles } from './styles';

// Types
import type { PartialFilterType } from '../../models/Types';

const ActiveRentals = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const activeTypes = useAppSelector((state) => state.filter.activeTypes);
  const activatedDaysRedux = useAppSelector((state) => state.filter.activatedDays);
  const [active, setActive] = useOptimisticState(activeTypes.active);
  const [activatedDays, setActivatedDays] = useOptimisticState(activatedDaysRedux);

  const handleToggleActiveType = () => {
    setActive(!active);
    const newActiveTypeFilter = {
      ...activeTypes,
      ...{ active: !active },
    };
    onFilterChange({ activeTypes: newActiveTypeFilter });
  };

  const handleDateClick = (activatedDays: number | null) => {
    setActive(true);
    setActivatedDays(activatedDays);
    const partialFilter = { activatedDays } as PartialFilterType;
    if (!active) {
      partialFilter.activeTypes = {
        ...activeTypes,
        ...{ active: true },
      };
    }
    onFilterChange(partialFilter);
  };

  const heading = (
    <LabeledControl
      controlId="activeType-active"
      label={
        <Label>
          <Heading level={4} css={{ textStyle: 'body-bold' }}>
            <Box css={dotStyles} />
            Active Rentals
          </Heading>
        </Label>
      }
      control={<Checkbox checked={active} onChange={() => handleToggleActiveType()} />}
    />
  );

  const component = (
    <FieldSet css={{ marginLeft: '1600' }}>
      <LabeledControl
        controlId="activeDays-all"
        label={<Label>All</Label>}
        control={<Radio checked={active && !activatedDays} onChange={() => handleDateClick(null)} />}
      />
      <LabeledControl
        controlId="activeDays-30"
        label={<Label>Within 30 days</Label>}
        control={<Radio checked={active && activatedDays === 30} onChange={() => handleDateClick(30)} />}
      />
      <LabeledControl
        controlId="activeDays-15"
        label={<Label>Within 15 days</Label>}
        control={<Radio checked={active && activatedDays === 15} onChange={() => handleDateClick(15)} />}
      />
      <LabeledControl
        controlId="activeDays-7"
        label={<Label>Within 7 days</Label>}
        control={<Radio checked={active && activatedDays === 7} onChange={() => handleDateClick(7)} />}
      />
    </FieldSet>
  );

  return FilterWrapper({
    heading,
    children: component,
    useCollapse: true,
  });
};

export default ActiveRentals;
